import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "slider" }
const _hoisted_2 = { class: "input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_slider = _resolveComponent("q-slider")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_slider, {
      color: "blue",
      "selection-color": "green",
      modelValue: _ctx.inputValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      modelModifiers: { number: true },
      min: _ctx.min,
      max: _ctx.max,
      "inner-min": _ctx.innerMin
    }, null, 8, ["modelValue", "min", "max", "inner-min"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_input, {
        modelValue: _ctx.inputValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValue) = $event)),
        modelModifiers: { number: true },
        outlined: "",
        "no-error-icon": "",
        type: "number",
        autofocus: "",
        dense: "",
        error: !_ctx.isValid
      }, null, 8, ["modelValue", "error"])
    ])
  ]))
}